var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29098 20.3263L6.48745 21.179L21.8353 17.6425L21.6388 16.7899L19.5406 15.4775L18.3617 10.3615C17.7527 7.7183 15.4854 5.78937 12.7801 5.62255L12.7232 5.37528C12.619 4.923 12.3393 4.53065 11.9458 4.28453C11.5523 4.03841 11.0772 3.95869 10.6249 4.0629C10.1726 4.16712 9.78028 4.44673 9.53416 4.84023C9.28804 5.23373 9.20832 5.70888 9.31254 6.16116L9.36951 6.40843C7.01001 7.74228 5.81548 10.4689 6.42453 13.1121L7.60335 18.2281L6.29098 20.3263ZM12.6525 20.6563C12.7567 21.1086 13.0363 21.501 13.4298 21.7471C13.8233 21.9932 14.2985 22.0729 14.7508 21.9687C15.203 21.8645 15.5954 21.5849 15.8415 21.1914C16.0876 20.7979 16.1674 20.3227 16.0631 19.8705",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellFull);
export default __webpack_public_path__ + "static/media/bell-full.2957bb1cba98968e4443c7418b955878.svg";
export { ForwardRef as ReactComponent };